import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home/index.vue'

// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => {
    return err
  })
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        keepAlive: true,
        showFooter: false,
        showTopBar: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js